/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { O as Orientation, V as Variants } from './constants-c94b83bd.js';
import { D as DHL_HEADLINE } from './constants-366d7065.js';

const DHL_STAGE_CONTENT_ALIGNMENT = {
    LEFT: Orientation.left,
    CENTER: Orientation.center,
    RIGHT: Orientation.right,
};
const DHL_STAGE_STAGE_VARIANTS = {
    ACTION_BOX: Variants.actionBox,
    COPY: Variants.copy,
    INTRO: Variants.intro,
    NUMBERS: Variants.numbers,
    TILES_HALF: Variants.tilesHalf,
    TILES_FULL: Variants.tilesFull,
    TRACKING: Variants.tracking,
};
const DHL_STAGE = {
    CONTENT_ALIGNMENT: DHL_STAGE_CONTENT_ALIGNMENT,
    MAIN_HEADLINE_COLOR: DHL_HEADLINE.COLOR,
    MAIN_HEADLINE_PRIORITY: DHL_HEADLINE.TAG,
    UPPER_HEADLINE_COLOR: DHL_HEADLINE.COLOR,
    UPPER_HEADLINE_PRIORITY: DHL_HEADLINE.TAG,
    STAGE_VARIANT: DHL_STAGE_STAGE_VARIANTS,
};

export { DHL_STAGE as D };

//# sourceMappingURL=constants-776886e7.js.map